/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import {
	StellantisQuoteRequestDTO,
	CreateQuoteRequestDto,
	QuoteRequestActionDto,
	StellantisMailDto,
} from '../models/StellantisDTO';
import { OpportunityCreateRequestDTO } from '../models/Opportunities/OpportunityCreateRequestDTO';
import { StellantisQuoteStatus } from '../models/Enums';

export class StellantisControllerService {
	constructor(public readonly httpRequest: BaseHttpRequest) {}

	public getQuoteRequests(config?: {
		skipLoadingIndicator?: boolean;
	}): CancelablePromise<Array<StellantisQuoteRequestDTO>> {
		return this.httpRequest.request({
			method: 'GET',
			url: '/register/stellantis-quotes/requests',
			headers: config?.skipLoadingIndicator
				? { 'x-skip-loading': '1' }
				: undefined,
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public getQuotes(): CancelablePromise<Array<StellantisQuoteRequestDTO>> {
		return this.httpRequest.request({
			method: 'GET',
			url: '/register/stellantis-quotes/quotes',
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public findQuote(id: string): CancelablePromise<StellantisQuoteRequestDTO> {
		return this.httpRequest.request({
			method: 'GET',
			url: `/register/stellantis-quotes/quotes/${id}`,
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public createOpportunity(
		id: string,
		payload: OpportunityCreateRequestDTO
	): CancelablePromise<{
		id: string;
		message: string;
		opportunityId: string;
	}> {
		return this.httpRequest.request({
			method: 'POST',
			url: `/register/stellantis-quotes/quotes/${id}/opportunity`,
			body: payload,
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public sendQuoteMail(
		id: string,
		body: StellantisMailDto
	): CancelablePromise<Array<StellantisQuoteRequestDTO>> {
		return this.httpRequest.request({
			method: 'POST',
			url: `/register/stellantis-quotes/quotes/${id}/mail`,
			body,
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public getQuotesHistory({
		skip,
		limit,
		orderBy,
		ascending,
		search,
		statuses,
		ids,
		requestDateFrom,
		requestDateTo,
	}: {
		skip?: number;
		limit?: number;
		orderBy?: string;
		ascending?: boolean;
		search?: string;
		statuses?: StellantisQuoteStatus[];
		ids?: string[];
		requestDateFrom?: string;
		requestDateTo?: string;
	} = {}): CancelablePromise<{
		totalCount: number;
		skip: number;
		limit: number;
		data: StellantisQuoteRequestDTO[];
	}> {
		// @ts-ignore
		return this.httpRequest.request({
			method: 'GET',
			url: '/register/stellantis-quotes/quotes-history',
			query: {
				skip,
				limit,
				orderBy,
				ascending,
				search,
				statuses,
				ids,
				requestDateFrom,
				requestDateTo,
			},
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public createQuoteRequest(
		payload: CreateQuoteRequestDto
	): CancelablePromise<StellantisQuoteRequestDTO> {
		return this.httpRequest.request({
			method: 'POST',
			url: '/register/stellantis-quotes/requests',
			body: payload,
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public takeQuoteRequestInCharge(id: string): CancelablePromise<any> {
		return this.httpRequest.request({
			method: 'POST',
			url: `/register/stellantis-quotes/requests/${id}/assign`,
			body: {},
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public unassignQuoteRequest(id: string, message): CancelablePromise<any> {
		return this.httpRequest.request({
			method: 'POST',
			url: `/register/stellantis-quotes/requests/${id}/unassign`,
			body: { id, message },
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public makeRequestUnquotable(id: string, message): CancelablePromise<any> {
		return this.httpRequest.request({
			method: 'POST',
			url: `/register/stellantis-quotes/requests/${id}/unquotable`,
			body: { id, message },
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public doQuoteRequest(
		id: string,
		payload: QuoteRequestActionDto
	): CancelablePromise<StellantisQuoteRequestDTO> {
		return this.httpRequest.request({
			method: 'POST',
			url: `/register/stellantis-quotes/requests/${id}/quote`,
			body: payload,
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}
}
